import { basicInfoAtom } from "@/atoms"
import { useAtomValue } from "jotai"
import { useEffect } from "react"

function updateManifest(name: string, logoUrl: string) {
  const manifest = {
    name,
    short_name: name,
    description: `Faca seu pedido em ${name}`,
    theme_color: "#10BC83",
    background_color: "rgba(0,0,0,0)",
    display: "standalone",
    start_url: "/",
    icons: [
      { src: logoUrl, sizes: "192x192", type: "image/png" },
      { src: logoUrl, sizes: "512x512", type: "image/png" },
    ],
  }

  const blob = new Blob([JSON.stringify(manifest)], { type: "application/json" })
  const url = URL.createObjectURL(blob)

  let link = document.querySelector<HTMLLinkElement>("link[rel='manifest']")
  if (!link) {
    link = document.createElement("link")
    link.rel = "manifest"
    document.head.appendChild(link)
  }
  link.href = url
}

export function useMerchantMetadata() {
  const basicInfo = useAtomValue(basicInfoAtom)

  useEffect(() => {
    if (!basicInfo) return

    if (basicInfo.name) {
      document.title = basicInfo.name

      const appleTitle = document.querySelector<HTMLMetaElement>(
        "meta[name='apple-mobile-web-app-title']"
      )
      if (appleTitle) {
        appleTitle.content = basicInfo.name
      }
    }

    const logoUrl = basicInfo.logoImage?.URL
    if (logoUrl) {
      const favicon = document.querySelector<HTMLLinkElement>("link[rel='icon']")
      if (favicon) {
        favicon.href = logoUrl
        favicon.type = "image/png"
      }

      const appleTouchIcon = document.querySelector<HTMLLinkElement>("link[rel='apple-touch-icon']")
      if (appleTouchIcon) {
        appleTouchIcon.href = logoUrl
      }
    }

    updateManifest(basicInfo.name || "", logoUrl || "/web-app-manifest-192x192.png")
  }, [basicInfo])
}
